import { ClipboardList } from "lucide-react";

export const OTHER_MOVEMENTS_FILTERS = [
	{
		key: "movement_type_id",
		label: "Tipo Movimiento",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar tipo de movimiento",
		options: [],
	},
	{
		key: "season_id",
		label: "Temporada",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar temporada",
		options: [],
	},
	{ key: "date_from", label: "Desde", type: "date", value: "", visible: true, placeholder: "Fecha desde" },
	{ key: "date_to", label: "Hasta", type: "date", value: "", visible: true, placeholder: "Fecha hasta" },
];

export const OTHER_MOVEMENTS_METADATA = {
	title: "Otros Movimientos",
	subtitle: "Visualiza todos los movimientos y ajustes de inventario",
	breadcrumb: "Otros Movimientos",
	icon: ClipboardList,
	path: "/historiales/otros_movimientos",
	apiType: "other_movements",
};

export const OTHER_MOVEMENTS_BASE_TABLE = {
	page: 1,
	per_page: 100,
	order_by: "date",
	order_dir: "desc",
};
